import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['resultContainer', 'fieldset'];

  disableForm() {
    this.fieldsetTarget.disabled = true;
  }

  displayResult(event) {
    const [data] = event.detail;
    if (data.age) {
      this.resultContainerTarget.innerHTML = renderAge(data);
    } else {
      this.displayError();
    }

    this.fieldsetTarget.disabled = false;
  }

  displayError() {
    this.resultContainerTarget.innerHTML = `<p class="mb-0 text-danger">Sorry there was an error, please try again.</p>`;
    this.fieldsetTarget.disabled = false;
  }
}

function renderAge({ age }) {
  const days = Number(age.day) + Number(age.week) * 7;

  return `
    <p class="mb-0">
      <span>${age.diff}</span><br>
      <span>years: ${age.year}, months: ${age.month}, days: ${days}</span><br>
      <span>years: ${age.year}, months: ${age.month}, weeks: ${age.week}, days: ${age.day}</span>
    </p>`;
}
